import styled from 'styled-components/macro';

import {useHistory, useLocation, useParams} from "react-router-dom";
import {useState} from "react";
import {Button, Input, InputGroup, InputLeftElement, Menu, MenuButton, MenuList} from "@chakra-ui/react";
import {useActions, useLoggedIn, useModal, useSettings} from "../store";
import {useBaseCommunity, useStoreCommunityTitle} from "../store/hooks";
import {isPseudoCommunity} from "../store/communites";
import NavLink from "./nav_link";
import MobileCommunitySidebar from "./mobile_community_sidebar";
import MobileNetworkSidebar from "./mobile_network_sidebar";
import CreatePost from "./create_post";
import Signup from "./signup";
import ProfileMenu from "./menus/profile_menu";
import Login from "./login";

import CreateCommunity from "./create_community";
import {themecolors} from "../utils/themecolors";
import Tooltip from "./tooltip";
import useProfilePicture from "../utils/profile_picture";
import ProfilePicture from "./profile_picture";
import {Bell, Compass, House, Pencil, Plus, Search, TrendingUp, Menu as LucideMenu, Moon} from "lucide-react";

const Logo = styled.div``;
const Desktop = styled.div``;
const Links = styled.div``;
const Link = styled.div``;
const Authenticate = styled.div``;
const LoginButton = styled.div``;
const SignupButton = styled.div``;
const SearchBox = styled.div``;
const UserIcons = styled.div``;
const UserIconItem = styled.div``;
const Profile = styled.div``;
const NewPost = styled.div``;
const Mobile = styled.div``;
const Unread = styled.div``;

const OpenSidebar = styled.div``;
const Location = styled.div``;
const Icons = styled.div``;
const Primary = styled.div``;
const CommunityInfo = styled.div``;
const Explore = styled.div``;
const Home = styled.div``;
const Trending = styled.div``;
const Create = styled.div``;
const Inbox = styled.div``;
const ProfileIcon = styled.div``;
const Dropdown = styled.div``;

const SearchSuggestions = styled.div``;
const Suggestion = styled.div``;

const MenuIcon = styled.div``;

const Left = styled.div``;
const Center = styled.div``;
const Right = styled.div``;

const TopBar = styled(({className, page, profile, customFeed, topics, legacyConversion, dark}) => {
    const loggedIn = useLoggedIn();
    const baseCommunity = useBaseCommunity();
    const {community : paramCommunity} = useParams();
    const community = paramCommunity || baseCommunity;
    const title = useStoreCommunityTitle(community, loggedIn, customFeed);
    const modal = useModal();
    const history= useHistory();
    const actions = useActions();
    const settings = useSettings();
    const {theme, profile_picture, username} = useSettings();
    const inbox_type = settings.unread === 0 ? 'all' : 'unread';
    const [query, setQuery] = useState('');
    const [profileMenu, setProfileMenu] = useState(false);
    const [communityInfo, setCommunityInfo] = useState(false);
    const [sidebar, setSidebar] = useState(false);
    const newPostLink = isPseudoCommunity(community) ? '/submit' : `/c/${community}/submit`;
    const handleProfile = () => {
        setProfileMenu(!profileMenu);
    };
    const handleCommunityInfo = () => {
        if (communityInfo) {
            modal.close();
        } else {
            modal.open(MobileCommunitySidebar, {community, profile, customFeed, topics});
        }
        setCommunityInfo(!communityInfo);
    };
    const handleSidebar = () => {
        if (sidebar) {
            modal.close();
        } else {
            modal.open(MobileNetworkSidebar);
        }
        setSidebar(!sidebar);
    };
    const handleTheme = async () => {
        const changes = {theme: settings.theme === 'light' ? 'dark' : 'light'};
        actions.settingsChanged(changes);
        modal.close();
    };
    const onInputChange = (event) => {
        setQuery(event.target.value);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        window.location.href = `/search?query=${query}${isPseudoCommunity(community) ? '' : `&community=${community}`}`;
    };
    const handleCreatePost = (event) => {
        event.preventDefault();
        const lowercaseCommunity = community?.toLowerCase();
        const prefillCommunity = (lowercaseCommunity === 'win' || lowercaseCommunity === 'all' || lowercaseCommunity === 'home') ? '' : community;
        modal.open(CreatePost, {community : prefillCommunity});
    };
    const handleCreateCommunity = (event) => {
        event.preventDefault();
        modal.open(CreateCommunity);
    };
    const handleLogin = () => {
        modal.open(Login);
    };
    const handleSignup = () => {
        modal.open(Signup);
    };

    const path = useLocation().pathname.toString();
    const isActive = path === '/' || path === '/active' || path === '/new' || path === '/top' || path === '/rising';

    return (
        <div className={`${className  } navbar`}>

            <Desktop className={"desktop"}>

                <Left>

                <NavLink href={'/'} react_route>
                    <Logo>
                    scored
                    </Logo>
                </NavLink>

                <Links>
                    <NavLink active={isActive} activeOnlyWhenExact href={loggedIn ? '/' : '/c/trending'} react_route>
                        <Tooltip content={'Home Feed'}>
                            <Link>
                                    <Home>
                                        <House size={20}/>
                                    </Home>
                            </Link>
                        </Tooltip>
                    </NavLink>
                    <NavLink href={'/c/trending'} react_route>
                        <Tooltip content={'Trending Feed'}>
                            <Link>
                                    <Trending>
                                        <TrendingUp size={20}/>
                                    </Trending>
                            </Link>
                        </Tooltip>
                    </NavLink>
                        <NavLink href={'/communities'} react_route>
                            <Tooltip content={'Communities'}>
                                <Link>
                                    <Explore>
                                        <Compass size={20}/>
                                    </Explore>
                                </Link>
                            </Tooltip>
                        </NavLink>
                </Links>

                </Left>

                <Center>
                    <SearchBox className={"search"}>
                        <form onSubmit={handleSubmit}>
                            <InputGroup>
                                <Input type="text" placeholder="Search" value={query} onChange={onInputChange} transitionDuration={'0'} />
                                <InputLeftElement
                                    pointerEvents="none"
                                    height={"40px"}
                                    margin={"0 6px"}
                                >
                                    <Search size={20} />
                                </InputLeftElement>
                            </InputGroup>
                        </form>
                    </SearchBox>
                </Center>

                <Right>

                {!loggedIn ?
                    <Authenticate>
                        <UserIcons>
                            <UserIconItem onClick={handleTheme}>
                                <Moon size={20}/>
                            </UserIconItem>
                        </UserIcons>
                        <LoginButton onClick={handleLogin}>
                            Login
                        </LoginButton>
                        <Button variant={"blue"} onClick={handleSignup}>
                            Sign Up
                        </Button>
                    </Authenticate>
                    :
                    <>
                        <Authenticate>
                            <UserIcons>
                                <NavLink href={`/messages?type=${inbox_type}`} react_route>
                                    <UserIconItem>
                                        {settings.unread > 0 && <Unread>{settings.unread > 99 ? 99 : settings.unread}</Unread>}
                                        <Bell size={20}/>
                                    </UserIconItem>
                                </NavLink>
                                {settings.community_creation &&
                                <Create onClick={handleCreateCommunity}>
                                        <Create>
                                            <UserIconItem>
                                                <Plus size={20}/>
                                            </UserIconItem>
                                        </Create>
                                    </Create>
                                }
                                {loggedIn &&
                                        <Create onClick={handleCreatePost}>
                                            <UserIconItem>
                                                <Pencil size={20}/>
                                            </UserIconItem>
                                        </Create>
                                }
                            </UserIcons>
                        </Authenticate>
                        <Dropdown>
                            <Menu placement={"bottom-end"} variant={"profileMenu"}>
                                <MenuButton>
                                    <Profile onClick={handleProfile}>
                                        <ProfileIcon>
                                            <ProfilePicture username={username} profilePicture={useProfilePicture(username, profile_picture, theme)} size={28}
                                            fontSize={16}/>
                                        </ProfileIcon>
                                    </Profile>
                                </MenuButton>
                                <MenuList>
                                    <ProfileMenu />
                                </MenuList>
                            </Menu>
                        </Dropdown>
                    </>
                }

                </Right>

            </Desktop>

            <Mobile>
                <OpenSidebar onClick={handleSidebar}>
                    <LucideMenu size={20}/>
                </OpenSidebar>
                <Location>{page ? page : title}</Location>
                <Icons>
                    {loggedIn ? <Primary onClick={handleCreatePost}>
                            <NavLink href={newPostLink}>
                                New Post
                            </NavLink>
                        </Primary> :
                        <Primary onClick={handleSignup}>
                            Sign Up
                        </Primary>
                    }
                    {loggedIn &&
                        <NavLink href={`/messages?type=${inbox_type}`} react_route>
                            <Inbox>
                                {settings.unread > 0 && <Unread>&#8226;</Unread>}
                                <Bell size={20}/>
                            </Inbox>
                        </NavLink>
                    }
                    <CommunityInfo onClick={handleCommunityInfo}>
                        <Search size={20}/>
                    </CommunityInfo>
                </Icons>
            </Mobile>
        </div>
    );
})`
  background-color: ${({theme, dark}) => theme.color.name === 'dark' ? (dark ? themecolors.dark_background_1 : themecolors.dark_background_2) : '#fff'};
  border-bottom: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_3 : 'rgb(219, 219, 219)'};

  
  ${Mobile} {
    display: none;
  }
  ${Desktop} {
    position: relative;
    max-width: ${({theme}) => theme.fullWidth ? '100%' : '1360px'};
    margin: 0 auto;
    flex: 0 0 52px;
    display: flex;
    align-items: center;
    height: 52px;
    padding: 0 24px;
    font-size: 15px;
    font-weight: 500;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.light_high_impact_text};
  }

  ${Logo} {
    font-family: 'Poppins';
    margin-right: 32px;
    display: flex;
    letter-spacing: -2px;
    font-size: 24px;
    align-items: center;
  }
  ${Logo} img {
    height: 18px;
    width: 66px;
  }
  ${Links} {
    display: flex;
  }
  ${Link}:hover, .active ${Link} {
    background-color: #80808012;
    border-radius: 48px;
  }
  ${Link} {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    white-space: nowrap;
    cursor: pointer;
    margin: 0 6px;
  }
  ${Authenticate} {
    margin-left: auto;
    display: flex;
    font-size: 15px;
    align-items: center;
  }
  ${LoginButton} {
    margin-right: 24px;
    margin-left: 8px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.light_high_impact_text};
    cursor: pointer;
    white-space: nowrap;
  }
  ${SignupButton}, ${NewPost} {
    padding: 6px 18px;
    border-radius: 40px;
    background-color: #307ad5;
    color: white;
    cursor: pointer;
    white-space: nowrap;
    font-weight: 400;
  }
  ${SignupButton} {
    font-weight: 500;
  }
  ${SearchBox} {
    flex-grow: 1;
    margin: 0 12px;
    position: relative;
    max-width: 520px;
    margin: 0 auto;
  }
  ${SearchBox} input {
    height: 40px;
    font-size: 15px;
    border: none;
    background-color: ${({theme}) => theme.color.name === 'dark' ? '#2c2c2c' : themecolors.light_input};
    border-radius: 48px;
    padding: 0 46px;
  }
  ${SearchBox} input::placeholder {
    color: ${({theme}) => theme.color.name === 'dark' ? 'rgba(255,255,255,.6)' : 'rgba(0,0,0,.4)'};
  }
  
  ${SearchSuggestions} {
    font-size: 16px;
    position: absolute;
    background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : '#fff'};
    border: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_3 : 'rgb(219, 219, 219)'};
    z-index: 2;
    margin-top: 16px;
    border-radius: 6px;
    width: 100%;
  }
  ${Suggestion} {
    font-weight: 400;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  ${Suggestion}:hover {
    background: ${({theme}) => theme.color.name === 'dark' ? theme.dark_border : themecolors.light_input};
  }
  ${Suggestion} svg {
    margin-right: 12px;
  }
  ${UserIcons} {
    display: flex;
    align-items: center;
    margin-right: 12px;
  }
  ${UserIconItem} {
    padding: 8px 10px;
    cursor: pointer;
    border-radius: 48px;
    margin: 0 6px;
  }
  ${UserIconItem}:hover {
    background-color: #80808012;
  }
  ${Authenticate} ${UserIconItem} {
    margin-right: 4px;
  }
  ${Profile} {
    display: flex;
    align-items: center;
    height: 36px;
    border-radius: 48px;
    cursor: pointer;
    line-height: 14px;
  }
  ${ProfileIcon} {
    padding: 0 8px;
  }
  ${Unread} {
    color: white;
    background-color: ${({theme}) => theme.placeholder_red_1};
    font-size: 12px;
    border-radius: 50%;
    height: 18px;
    width: 18px;
    position: absolute;
    margin-top: -8px;
    margin-left: 14px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ${CommunityInfo}, ${Inbox} {
    padding: 8px;
  }
  ${CommunityInfo} {
    margin-right: 12px;
  }
  ${Explore} {
    display: flex;
    align-items: center;
  }
  ${MenuIcon} {
    display: flex;
    align-items: center;
    margin-right: 16px;
    margin-left: 6px;
    justify-content: center;
  }
  @media only screen and (max-width: 1060px) {
    ${SearchBox} { 
      display: none;
    }
  }
  @media only screen and (max-width: 1036px) {
    ${Logo} {
      margin-right: 24px;
    }
    ${Links} {
      margin-right: 6px;
    }
  }
  @media only screen and (max-width: 960px) {
    ${Link}, ${Link} svg {
      margin-right: 0;
    }
  }
  @media only screen and (max-width: 780px) {
    ${Desktop} {
      display: none;
    }
    ${Unread} {
      font-size: 23px;
      display: initial;
      border-radius: 0;
      background-color: transparent;
      color: ${({theme}) => theme.placeholder_red_1};
      margin-top: -14px;
      margin-left: 10px;
    }
    ${Mobile} {
      font-weight: 400;
      display: flex;
      height: 100%;
      align-items: center;
      white-space: nowrap;
    }
    ${Location} {
      margin-left: 4px;
      overflow: hidden;
    }
    ${OpenSidebar} {
      font-size: 18px;
      padding: 12px;
      margin-left: 8px;
    }
    
    ${Icons} {
      margin-left: auto;
      font-size: 18px;
      display: flex;
      align-items: center;
    }

    ${Primary} {
      margin-right: 6px;
      border-radius: 4px;
      cursor: pointer;
      margin-left: 12px;
      font-size: 14px;
      background-color: ${({theme}) => theme.color.name === 'dark' ? 'rgba(0,0,0,.3)' : 'rgba(0,0,0,.12)'};
      color: ${({theme}) => themecolors.pure_white};
      font-weight: 400;
      padding: 6px 16px;
    }
    
    height: 50px;
    flex: 0 0 50px;
    
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
      font-weight: 500;
      color: ${({theme}) => themecolors.pure_white};
      background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : '#161616'};

    ${({theme, legacyConversion}) => theme.color.name !== "dark" && legacyConversion ? `
        background-color: #001b2a;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.25);
        border-bottom: 0;
    ` : ''};
  }
  
  ${Left}, ${Center}, ${Right} {
    display: flex;
    align-items: center;
  }
  ${Left}, ${Right} {
    width: 292px;
  }
  ${Center} {
    flex-grow: 1;
  }
  ${Desktop} {
    justify-content: space-between;
  }
`;

export default TopBar;
